import { Box, Paper, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import CheckIcon from "@mui/icons-material/Check";

type StepIndicatorCardProps = {
  stepNumber: number;
  icon: ReactNode;
  title: string;
  subtitle: string;
  isActive: boolean;
  isCompleted: boolean;
};

export const StepIndicatorCard = ({
  stepNumber,
  icon,
  title,
  subtitle,
  isActive,
  isCompleted,
}: StepIndicatorCardProps) => (
  <Paper
    variant="outlined"
    sx={{
      flex: 1,
      borderRadius: "12px",
      p: 2,
      ...(isActive && { borderColor: "#101828", borderWidth: "2px" }),
      ...(isCompleted && { bgcolor: "#ECFDF3", borderColor: "#12B76A" }),
    }}
  >
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minWidth={36}
        height={36}
        borderRadius="50%"
        bgcolor={isCompleted ? "#12B76A" : isActive ? "#FF8D3F" : "#F2F4F7"}
        color={isCompleted || isActive ? "#FFFFFF" : "#667085"}
      >
        {isCompleted ? (
          <CheckIcon fontSize="small" />
        ) : (
          <Typography fontSize={14} fontWeight={600} color="inherit">
            {stepNumber}
          </Typography>
        )}
      </Box>
      <Box sx={{ "& svg": { color: "#FF8D3F" } }}>{icon}</Box>
      <Box>
        <Typography fontSize={14} fontWeight={600} color="#101828">
          {title}
        </Typography>
        <Typography fontSize={12} color="#667085">
          {subtitle}
        </Typography>
      </Box>
    </Stack>
  </Paper>
);
